// DO NOT MODIFY! THIS FILE IS AUTOGENERATED BY generate-endpoint-spec.util.ts

import { RequestHandler } from 'express';

export const TSpecRoute_postExcuseAttendanceBonus = (path: TSpecPathPostExcuseAttendanceBonus) => {
  let res = "/attendance-bonus/:id/excuse";
  Object.entries(path).map(([key, value]) => {
    res = res.replace(':' + key, value);
  });
  return res;
};

export type TSpecHandler_postExcuseAttendanceBonus = RequestHandler<TSpecPathPostExcuseAttendanceBonus, any, TSpecBodyPostExcuseAttendanceBonus, TSpecQueryPostExcuseAttendanceBonus, {}>;

export interface TSpecPathPostExcuseAttendanceBonus { id: string; }

export interface TSpecBodyPostExcuseAttendanceBonus {
  note?: string;
}

export interface TSpecQueryPostExcuseAttendanceBonus {
  AppVersion?: string;
  AppUser?: string;
}
